// extracted by mini-css-extract-plugin
export var layoutContainer = "_3s-0";
export var layoutContainerOpen = "_3s-5";
export var layoutContainerResizing = "_3s-1";
export var mainContent = "_3s-2";
export var resizeDivider = "_3s-3";
export var slidePanel = "_3s-4";